import { ConditionCode } from '@/shared/api/protocol-ts/model/dto_report_condition_codes_pb';

export const collectConditionCodesFromGroups = (
  groups: Record<string, ConditionCode[]>,
): ConditionCode[] => {
  return Object.values(groups).flatMap((conditionCodes) => conditionCodes);
};
